import React, { Component } from 'react'
import ContractCard from '../../components/ContractCard'
import map from 'lodash/map'
import propTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import withRouter from '../../components/withRouter'
import contractService from '../../service/contract.service'
import ContractVerificationPage from './ContractVerificationPage'
import t from '../../service/translate.service'

class ContractList extends Component {
  static propTypes = {
    contractStore: propTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    extendObservable(this, {
      modal: {
        visible: false,
      }
    })
  
  } 

  componentDidMount() {
    this.props.contractStore.verificationStarted = false
  }

  showModal = () => {
    this.modal.visible = true
  }

  openContractOverview = (contract) => {
    if(!contract.active || !contract.valid) return

    if (contractService.checkIsContractCondominium(contract.contractNumber)) {
      this.props.navigate(`/contract-overview-condo/${contract.contractNumber}`)
    } else {
      this.props.navigate(`/contract-overview/${contract.contractNumber}`)
    }

    this.props.contractStore.selectedContract = contract
  }

  checkIfCanOpenContract = (contract) => {
    if(!contract[0].active || !contract[0].valid) return true
  }

  closeVerificationModal = () => {
    this.showVerificationSuccessModal = false
  } 

  render() {
    return (
      <div className="contract-list" aria-live="polite">
        {this.props?.contractStore?.verificationStarted && (
          <ContractVerificationPage
            isAddingContract={false}
            redirectUrl="/contracts"
            aria-labelledby="contract-verification-page"
          />
        )}
        {Boolean(this.props.contractStore.contracts.length) && this.props.contractStore.isRabFetched && (
          <div className="contracts-holder" aria-labelledby="contracts-list">
            {map(this.props.contractStore.contracts, c => (
              <div
                className={`contractCardWrapper`}
                key={c.id}
                aria-labelledby={`contract-${c.id}`}
              >
                <ContractCard
                  clickable={this.checkIfCanOpenContract([c]) ? false : true}
                  key={c.id}
                  contract={c}
                  currContractNum={this.currContractNum}
                  onClick={this.openContractOverview}
                  contractStore={this.props.contractStore}
                  aria-label={`${t.CONTRACT_NUMBER_OVERVIEW} ${c.contractNumber}`}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}

export default inject('contractStore')(withRouter(observer(ContractList)))
